<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model.trim="searchForm.roleName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="角色状态" prop="status">
            <el-select v-model="searchForm.status" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option label="启用" value="Y" />
              <el-option label="停用" value="N" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="{ $index }">
            {{ tableData.pageSize * (tableData.pageNum - 1) + $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="roleCode" label="角色编码" min-width="150"></el-table-column>
        <el-table-column prop="roleName" label="角色名称" min-width="200"></el-table-column>
        <el-table-column prop="describe" label="角色描述" min-width="300"></el-table-column>
        <el-table-column prop="status" label="角色状态" width="100"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="editRow(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'DataPermissionManagement',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      searchForm: {
        status: 'Y',
        roleName: '',
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      statusList: [],
      goodsLocationList: [],
      productTypeList: [],
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(val, olv) {
        if (
          olv.path == '/configurationCenter/dataPermissionConfiguration' &&
          JSON.stringify(val.params) != '{}' && val.params.type
        ) {
          this.init();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    //使用办公平台查询电商角色分页接口 对应传参需跟进环境判断
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          appId: process.env.BUILD_ENV === 'prod' ? '121' : '61',
          appCode: 'e-commerce',
          subAppId: process.env.BUILD_ENV === 'prod' ? '1923' : '3361',
        },
      };
      this.$q.configurationCenter
        .rolePageInfo({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    editRow(row) {
      this.openSubPage({ name: 'DataPermissionConfiguration', query: { row: JSON.stringify(row) } });
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: 'string',
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != '图片'); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== '图片');
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped></style>
